import { motion } from "framer-motion";

export const PageHero = ({ kicker, title, sub, testId }) => (
  <section
    data-testid={testId}
    className="relative overflow-hidden bg-gradient-to-b from-sinovar-soft to-white pt-32 md:pt-40 pb-14 md:pb-20"
  >
    <div className="mx-auto max-w-5xl px-5 md:px-8">
      {kicker && (
        <motion.span
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-xs font-semibold uppercase tracking-[0.16em] text-sinovar-red"
        >
          {kicker}
        </motion.span>
      )}
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.05 }}
        className="mt-4 font-display text-4xl md:text-6xl font-bold tracking-tighter text-sinovar-navy leading-[1.02] whitespace-pre-line"
      >
        {title}
      </motion.h1>
      {sub && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="mt-6 max-w-2xl text-base md:text-lg text-sinovar-navy/70 leading-relaxed"
        >
          {sub}
        </motion.p>
      )}
    </div>
  </section>
);
